import $ from 'jquery';
import targetingTemplate from '../templates/targeting.hbs';
import targetingSiteTemplate from '../templates/targetingSite.hbs';
import {ajaxRequest} from '../../sinclair/sinclair.ajax';
import {filterList} from '../../sinclair/sinclair.utils';

function fetchUserModel() {
    const deferred = $.Deferred();
    const userOpts = {
        url: '/platform/facade/user/active/compressed/',
        type: 'GET',
        beforeSend() {},
        complete() {},
        success(data) {
            if (data.data && data.data.length) {
                data = data.data[0];
            }
            deferred.resolve(data);
        },
    };

    ajaxRequest(userOpts);

    return deferred;
}

// eslint-disable-next-line max-statements
$.fn.sdaTargeting = function(data) {
    const that = this;
    const userModel = {};

    that[0].type = 'sdaTargeting';

    data = data || {};
    $.extend(data, that.data());

    that.addClass('sda-targeting');
    that.html(targetingTemplate(data));

    const $selectList = that.find('.sda-select-list').sdaSelectList();
    const $selectedGroup = that.find('.selected-item-group');
    const $searchInput = that.find('.sda-targeting-search');

    const deferred = fetchUserModel(userModel);
    deferred.done(function(userData) {
        $selectList.data().clearList();
        $.each(userData.availableTargets, function(i, target) {
            $selectList.data().addItem($(targetingSiteTemplate(target)));
        });
    });

    that.find('.sda-targeting-search')
        .on('focus', function() {
            if (!that.find('.selected-item-visible').length) {
                $selectList.open();
            }
        })
        .on('focusout', function() {
            if (that.is(':hover')) {
                if (!$selectedGroup.find('.remove-target').is(':hover')) {
                    that.find('.sda-targeting-search').focus();
                }
            } else {
                $selectList.close();
            }
        });
    that.find('.sda-targeting-search').on('keyup', function(e) {
        const searchString = $(e.target)
            .val()
            .split('/')
            .join(' ');
        const exclude = ['targetId'];

        if (e.which === 27) {
            $(e.target).val('');
        }

        if (searchString.length) {
            filterList($selectList.find('[data-selectable]'), searchString, exclude);
        } else {
            $('.story-target li').show();
        }
    });

    $selectedGroup.find('.remove-target').on('click', function() {
        that.val(false);
        $searchInput.blur().val('');
    });

    $selectList.on('change.val', function(e) {
        const $selectedData = $(e.target)
            .find('.selected')
            .data();

        e.stopPropagation();
        that.val($selectedData);
        $selectList.close();
    });

    if (data.val) {
        that.val(data);
    }

    return that;
};

$.valHooks.sdaTargeting = {
    get(el) {
        return $(el)
            .find('.selected-item')
            .data().val;
    },
    set(el, data) {
        const that = $(el);
        const $selectedInput = that.find('.selected-item');

        if (data) {
            that.find('.selected-item-group').addClass('selected-item-visible');
            $selectedInput.val(data.url);
            $selectedInput.data({val: data.val});
        } else {
            $selectedInput.data({val: null});
            that.find('.selected-item-group').removeClass('selected-item-visible');
        }

        that.find('.sda-targeting-search').blur();
        that.trigger('change.val', data.val);

        return data.val;
    },
};

export default $;
